import { render, staticRenderFns } from "./RecommendationMessageBox.vue?vue&type=template&id=0d078a0e&scoped=true"
import script from "./RecommendationMessageBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendationMessageBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RecommendationMessageBox.vue?vue&type=style&index=0&id=0d078a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d078a0e",
  null
  
)

export default component.exports